import { PlanType } from 'apps/shared/scripts/__generated__/graphql.generated';

export const PLAN_TYPES = {
  [PlanType.Pro]: 'pri_01j4r4787hvdqtgwefk3hkqt57',
};
